import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import SearchBox from "@/components/feature/SearchBox";

const navItems = [
  { label: "首页", to: "/", end: true },
  { label: "电视剧", to: "/category" },
  { label: "资讯", to: "/news" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background-50/90 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20 gap-4">
          <Link to="/" className="flex items-center gap-3 shrink-0 group">
            <span className="w-10 h-10 rounded-lg bg-primary-700 text-accent-300 flex items-center justify-center text-xl transition-transform group-hover:scale-105">
              <i className="ri-sparkling-2-fill"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg md:text-xl font-semibold text-foreground-950 tracking-wide">
                仙剑奇侠传
              </span>
              <span className="text-[11px] tracking-[0.3em] text-primary-600 mt-1">
                仙侠影视站
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? "text-primary-700 bg-primary-100"
                      : "text-foreground-700 hover:text-primary-700 hover:bg-primary-50"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:block w-64 lg:w-80">
            <SearchBox />
          </div>

          <div className="flex md:hidden items-center gap-1">
            <button
              type="button"
              aria-label="搜索"
              onClick={() => {
                setMobileSearchOpen((prev) => !prev);
                setMobileOpen(false);
              }}
              className="w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-xl"></i>
            </button>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => {
                setMobileOpen((prev) => !prev);
                setMobileSearchOpen(false);
              }}
              className="w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className={mobileOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileSearchOpen && (
        <div className="md:hidden px-4 pb-4 animate-fade-in">
          <SearchBox />
        </div>
      )}

      {mobileOpen && (
        <nav
          className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3 animate-fade-in"
          aria-label="移动端导航"
        >
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `block px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                      isActive
                        ? "text-primary-700 bg-primary-100"
                        : "text-foreground-700 hover:bg-primary-50"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
}